'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useClickOut, useLabel } from '@websolutespa/bom-mixer-hooks';
import { AnimatePresence, motion } from 'motion/react';
import { useRef } from 'react';
import { useActions } from '../../../useLlm/useActions';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-prompt.module.scss';

export const PagePrompt: React.FC = () => {
  const label = useLabel();
  const {
    PageActions,
    PageContext,
    PageDictate,
    PageMenu,
    PageStop,
    PageStreamingIndicator,
    PageSubmit,
    PageSynthesis,
    PageTextarea,
    PageTrigger,
    PageUpload,
  } = useLlm(state => state.components);
  const ref = useRef<HTMLDivElement>(null);
  const streaming = useLlm(state => state.streaming);
  const opened = useLlmView(state => state.opened);
  const { open } = useLlmView(state => state.actions);

  const idle = useLlmView(state => {
    const { idle, opened } = state;
    // const shouldShowTrigger = (!opened && !idle && !embed && !imperative) || Boolean(app?.contents.customIntro && !introed);
    return idle && !opened;
  });

  const { wrapper } = useActions();

  useClickOut(ref, (event) => {
    const className = (event.target as HTMLElement)?.getAttribute('class') || '';
    // console.log('useClickOut', className);
    if (className.indexOf('llm') === -1 && opened) {
      open();
    }
  });

  // console.log('idle', idle);

  return (
    <AnimatePresence>
      {!idle && (
        <motion.section
          ref={ref}
          className={getClassNames(style.prompt, {
            [style.open]: opened,
          })}
          initial={{ y: '200%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '200%', opacity: 0 }}
          transition={{ duration: .4 }}
          aria-label="Prompt"
        >
          <PageTrigger />
          {wrapper ? (
            <PageActions wrapper={wrapper} />
          ) : (
            <form className={getClassNames(style.form, '-form')} onSubmit={(event: React.FormEvent) => event.preventDefault()}>
              <PageMenu />
              <div className={getClassNames(style.control, {
                [style.streaming]: streaming,
              })}>
                <PageStreamingIndicator />
                <PageTextarea />
                <PageUpload />
                <PageContext />
                <PageDictate />
                <PageSynthesis />
              </div>
              {streaming ? (
                <PageStop />
              ) : (
                <PageSubmit />
              )}
            </form>
          )}
        </motion.section>
      )}
    </AnimatePresence>
  );
};
